import { useTranslation } from 'react-i18next';

import { Translate } from 'components/Translate/Translate';

export const InfoBlock = ({
  fieldDescription,
  isErrorFixed,
  isPendingValidation,
}: {
  fieldDescription?: React.ReactNode;
  isErrorFixed?: boolean;
  isPendingValidation?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 empty:hidden">
      {fieldDescription && !isErrorFixed ? (
        <div className="rounded-md bg-gray-50 px-3 py-2">
          <p className="text-sm text-gray-600">
            <Translate i18nKey={'webedi:fieldAnnotation.fieldDescriptionLabel'} /> {fieldDescription}
          </p>
        </div>
      ) : null}
      {isPendingValidation ? (
        <div className="rounded-md bg-blue-50 px-3 py-2">
          <p className="text-sm font-semibold text-blue-700">{t('webedi:fieldAnnotation.pendingValidation.title')}</p>
          <p className="text-sm text-blue-600">{t('webedi:fieldAnnotation.pendingValidation.description')}</p>
        </div>
      ) : null}
    </div>
  );
};
